import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import BookCard from "@/components/BookCard";
import { Section, SectionHeading } from "@/components/Section";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Books() {
  const [books, setBooks] = useState([]);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    axios.get(`${API}/books`).then((r) => setBooks(r.data)).catch(() => {});
  }, []);

  const filters = ["all", "Paranormal Romance", "Urban Fantasy", "Contemporary Romance", "Cozy Mystery"];
  const filtered =
    filter === "all" ? books : books.filter((b) => b.genre === filter);

  return (
    <div className="page-wrapper pt-32 md:pt-40">
      <Section testId="books-page">
        <SectionHeading
          overline="The Library"
          title="Every story. Every hero. Every happily-ever-after."
          kicker="The complete published works of Ellie Stone — paranormal, urban fantasy, contemporary, and cozy mystery."
        />

        <div className="flex flex-wrap gap-3 mb-16">
          {filters.map((f) => (
            <button
              key={f}
              data-testid={`books-filter-${f.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => setFilter(f)}
              className={`px-5 py-2 text-xs font-mono uppercase tracking-widest transition-all duration-300 border ${
                filter === f
                  ? "border-[#D4AF37] text-[#D4AF37] bg-[#D4AF37]/5"
                  : "border-[#D4AF37]/10 text-[#F4F4F6]/60 hover:text-[#F4F4F6] hover:border-[#D4AF37]/30"
              }`}
            >
              {f === "all" ? "All Books" : f}
            </button>
          ))}
        </div>

        {filtered.length === 0 ? (
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="text-[#A0A4AE] text-center py-20"
          >
            No books in this category yet.
          </motion.p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {filtered.map((b, i) => (
              <BookCard key={b.id} book={b} index={i} />
            ))}
          </div>
        )}
      </Section>
    </div>
  );
}
